<template>
  <div v-if="hasMotion" class="motion-sliders use-bscroll" style="width:100%; height:calc(100% - 60px); overflow-y:overlay; overflow-x:hidden">
    
    <!--Object Animation sliders-->
    <div class="row no-gutter">
        <div class="col-md-4">
            <div style="padding:15px 10px 10px 30px;height:48px;background:white;"
                v-for="(motion,index) of motions" :key="index">
                <div class="left-align">
                    {{getName(motion.TYPE)}}
                    <i class="icon icon-trash clickable right-end" style="padding-top:3px;margin-left:5px" @click="delAllKeyFrames(motion.TYPE)" ></i>
                    <i class="icon icon-x clickable right-end" style="padding-top:3px;" @click="delMotion(motion.TYPE)" ></i>
                </div>
            </div>
        </div>

        <div class="col-md-20">
            
            <div style="padding:10px 0px 10px 0px;height:48px;background:white;"
                v-for="(motion,index) of motions" :key="index" @click="onUserClickMotionSlider(motion.TYPE)">
                <vue-slider class="is-progress-slider inline is-vertical-mid" 
                v-model="keyFrames[index]" width="90%" :clickable="false"
                :tooltip="'none'"
                :process-style="{'background-color': '#526780'}" 
                :duration="0" v-on:change="onKeyFramePosChange" v-on:drag-start="onDragStart"
                :min="playBackMinMax[0]" :max="playBackMinMax[1]"
                :contained="true" :adsorb="true"></vue-slider>
            </div>

        </div>
    </div>

   </div>
</template>

<script>
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { Scene } from '../../lib/bezieLib/Scene';
import { BMotionType, BMotionEnums } from '../../lib/bezieLib/Animations/BMotionEnums';
import { BMotion2, BMotionLabel } from '../../lib/bezieLib/Animations/BMotion2';
import { BezieApp } from '../../lib/bezieLib/BezieApp';


export default {
    name: 'MotionSliders',
    props: { bezieAppObj : BezieApp },
    components: {},
    data: function(){
        return{
            playBackMinMax : [0,100],
            bObject: null,
            hasMotion: false,
            motions: [],
            keyFrames: [],
            tempKeyFrameArray: [],
            userChangedKeyFrameLoc: false
        }
    },
    methods:{
        getKeyFrames: function (motion, index, motions) {
            //var kf;
            var frames = [];
            for( var kf of motion.keyFrames){
                frames.push(kf.frame);
            }
            //console.log("motion:"+motion.TYPE);
            //console.log(frames);
            return frames;
        },
        rebuildKeyFrames(){
            for(var i=0;i<this.motions.length; i++){
                this.keyFrames[i] = [];
                var motion = this.motions[i];
                var keys = motion.keyFrames.holder.keys();
                for(let k of keys){
                    this.keyFrames[i].push(k);
                }
                /*for(var j=0;j<motion.keyFrames.size(); j++){
                    this.keyFrames[i].push(motion.keyFrames[j].frame)
                }*/
            }
        },
        getName: function(type){
            return BMotionEnums.getBMotionName(type);
        },
        delAllKeyFrames: function(type){
            this.bObject.deleteMotion(type);
            this.init();
        },
        delMotion: function(type){
            //this.bObject.deleteMotion(type);
        },
        updateKeyFrameLoc(type, tempKeyFrames){
            var motion = this.bObject.getMotion(type);
            var replaced = false;
            if(motion){
                var keys = motion.keyFrames.holder.keys();
                var i = 0;
                var len = tempKeyFrames.length;
                for(let k of keys){
                    if(i<len){
                        if(k != tempKeyFrames[i]){
                            motion.replaceKeyFrame(k, tempKeyFrames[i]);
                            replaced = true;
                            console.log("replaced");
                            break;
                        }    
                    }else{
                        console.log("break");
                        break;
                    }
                    i++;
                }
            }
            return replaced;
        },
        onUserClickMotionSlider: function(type){
            console.log("user clicked motion slider: "+type+" val:"+this.tempKeyFrameArray);
            if(this.userChangedKeyFrameLoc){
                var replaced = this.updateKeyFrameLoc(type, this.tempKeyFrameArray);
                this.userChangedKeyFrameLoc = false;
                this.tempKeyFrameArray = [];
                if(replaced){
                    this.init();
                }
            }
        },
        onKeyFramePosChange: function(val){
            this.tempKeyFrameArray = val;
            this.userChangedKeyFrameLoc = true;
        },
        onDragStart: function(index){
            console.log("drag start:"+index);
        },
        onUpdate : function(obj){
            //TODO: Selection change listener has extra parameter in onUpdate
            console.log("on update called for motionslider");
            this.reset();
            if(obj) {
                this.init();
            }
        },
        reset: function(){
            this.motions = [];
            this.hasMotions = false;
            this.keyFrames = [];
        },
        init: function(){
            console.log("init motion slider");
            this.reset();
            if(this.bezieAppObj){
                this.bObject = this.bezieAppObj.getScene().getSelectedObject();

                if(this.bObject!=null && this.bObject.isMotionObject() && this.bObject.hasMotions()){
                    this.motions = this.bObject.getAnimatedMotions();
                    this.rebuildKeyFrames();
                    //If scene changes, this should be taken care manually.
                    this.playBackMinMax = this.bezieAppObj.getScene().getFrameRange(); 
                    this.hasMotion = true;
                }
            }
        }
    },
    mounted: function(){
        console.log("motion slider mounted");
        if(this.bezieAppObj){  
            this.init();
        }
        UIUpdate.addObjectUpdateListener(this);
        UIUpdate.addSelectionChangeListener(this);
    },
    beforeDestroy: function(){
        console.log("motion slider destroyed");
        UIUpdate.removeSelectionChangeListener(this);
        UIUpdate.removeObjectUpdateListener(this);
        this.reset();
    }
}
</script>

<style>

.is-progress-slider{
  margin: 5px 12px 5px 12px;
}

.is-vertical-mid{
    vertical-align: middle
}

.right-end{
    float: right;
}

.left-align{
    text-align: left;
}

.right-align{
    text-align: right;
}

</style>
